module.exports = __webpack_public_path__ + "img/service_img21.be9db399.png";